import React, { useEffect, useState } from 'react';

function getAuthState() {
    try {
        const stored = localStorage.getItem('pinkWalletAuth');
        return stored ? JSON.parse(stored) : null;
    } catch (error) {
        console.error('Error reading auth state:', error);
        return null;
    }
}

/**
 * Pinned Pink Wallet feed post. Shows a welcome + card/profile links when
 * logged in, mirroring the original hero behavior (simple variant).
 */
export default function PinnedPost() {
    const [authState, setAuthState] = useState(null);

    useEffect(() => {
        const updateAuthState = () => setAuthState(getAuthState());
        updateAuthState();
        const handleAuthChange = (event) => setAuthState(event.detail);
        window.addEventListener('authStateChanged', handleAuthChange);
        return () => window.removeEventListener('authStateChanged', handleAuthChange);
    }, []);

    const handleShowCard = () => {
        window.dispatchEvent(new CustomEvent('showMembershipCard'));
    };

    const firstName = authState?.name?.split(' ')[0] || 'Member';
    const isLoggedIn = authState !== null;

    return (
        <article className="post post--featured">
            <div className="post-head">
                <div className="story-ring">
                    <img src="/assets/logo.svg" alt="Pink Wallet" className="w-11 h-11 rounded-full bg-white" width="44" height="44" />
                </div>
                <div className="post-author">
                    <p className="post-name">Pink Wallet</p>
                    <a href="https://www.instagram.com/pinkwalletgr" target="_blank" rel="noopener noreferrer" className="no-underline inline-flex">
                        <p className="post-handle">@pinkwalletgr</p>
                    </a>
                </div>
                </div>

            {isLoggedIn ? (
                <>
                    <h1 className="post-title">Welcome back, {firstName}!</h1>
                    <p className="post-caption mb-5">Discover LGBTQ+ events and businesses in West Michigan.</p>
                    <div className="flex flex-wrap gap-3">
                        <button type="button" onClick={handleShowCard} className="post-cta">Show My Card</button>
                        <a href="/profile/" className="post-cta post-cta--ghost">My Profile</a>
                    </div>
                </>
            ) : (
                <>
                    <h1 className="post-title">Keep your money local, keep your money queer.</h1>
                    <p className="post-caption mb-5">Discover LGBTQ+ events and businesses in West Michigan.</p>
                    <div className="flex flex-wrap gap-3">
                        <a href="/subscribe/" className="post-cta">Join Pink Wallet</a>
                        <a href="/login/" className="post-cta post-cta--ghost">Log In</a>
                    </div>
                </>
            )}
        </article>
    );
}